module.exports = __webpack_public_path__ + "3zpswMH.png";